export default {
  neutral:           '#aaaaaa',

  noReply:           '#809495',
  hasReply:          '#a9c5c7',

  open:              '#8d4648',
  pending:           '#9e7e5f',
  reassigned:        '#94a473',
  inProgress:        '#8caaaf',
  closed:            '#b8b8b8',

  facebook:          '#3b5998',
  twitter:           '#55acee',

  byBrand:           '#ababab',
  byConsumer:        '#5e5e5e',

  level1:            '#acd5e8',
  level2:            '#94d498',
  level3:            '#b2c271',
  level4:            '#b09523',
  level5:            '#966129',
  level6:            '#823737',

  user:              '#407F41',
  job:              '#565EB0'
}